import React from "react";

import { useSectionList } from "src/modules/htx/dashboard/useSectionList";
import {
	filterSectionList,
	Search,
	SectionList
} from "src/modules/shared/dashboard";

export const Dashboard: React.FunctionComponent = () => {
	const [query, setQuery] = React.useState("");
	const sections = useSectionList();
	const filteredSections = React.useMemo(
		() => filterSectionList(sections, query),
		[sections, query]
	);
	return (
		<>
			<Search query={query} onChangeQuery={setQuery} />
			<SectionList sections={filteredSections} />
		</>
	);
};
